module.exports = __webpack_public_path__ + "resources/images/prullenbak-900f796b0fc6fb78dc9c8f73971e1ccc-cache.jpg";